import { NoContentData } from '@lastbrand/storefront-proto-registry/api/v1/widget'
import React from 'react'

import { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import NoProduct from '@src/pages/[...slug]/components/collection/molecules/noProducts/NoProduct'
import { useFilterSortContext } from '@src/pages/clp1/contexts/filter-sort-context'

export function NoContentLegacyWidget(props: PLTypedWidgetProps<NoContentData>) {
  const { clearAllFilters } = useFilterSortContext()
  const filtersApplied = props.data.noContentData?.filtersApplied ?? false

  return <NoProduct onResetFilters={clearAllFilters} isFiltersApplied={filtersApplied} />
}
